import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/networkHandler";
export const tokenConfig = (getState) => {
  const token = getState().auth.accessToken;

  const config = {
    headers: {},
  };

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
};

// Get Invoice
export const getInvoices = createAsyncThunk(
  "user/all-invoice",
  async (
    { page, rowsPerPage, name, status },
    { getState, rejectWithValue }
  ) => {
    try {
      const config = tokenConfig(getState);
      let params = `page=${page + 1}&limit=${rowsPerPage}`;
      if (name) {
        params += `&name=${encodeURIComponent(name)}`;
      }
      if (status) {
        params += `&status=${encodeURIComponent(status)}`;
      }
      const response = await axios.get(
        `/user/advertiser-billings?${params}`,
        config
      );
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Make Payment
export const makePayment = createAsyncThunk(
  "admin/make-payment",
  async (form, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.post("/user/make-bill-payment", form, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Billing Payments
export const getPayments = createAsyncThunk(
  "user/billing-payments",
  async (
    { page, rowsPerPage, name, status, partyType },
    { getState, rejectWithValue }
  ) => {
    try {
      const config = tokenConfig(getState);
      let params = `page=${page + 1}&limit=${rowsPerPage}`;
      if (name) {
        params += `&name=${encodeURIComponent(name)}`;
      }
      if (status) {
        params += `&status=${encodeURIComponent(status)}`;
      }
      if (partyType) {
        params += `&partyType=${encodeURIComponent(partyType)}`;
      }
      const response = await axios.get(
        `/user/billing-payments?${params}`,
        config
      );
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);
//Get Account Details
export const getAccountDetails = createAsyncThunk(
  "admin/account-details",
  async (_, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get(`/campaign/company-account`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
)




const billingSlice = createSlice({
  name: "billing",
  initialState: {
    loading: false,
    invoices: [],
    payments: [],
    accountDetails: [],
    meta: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // get invoices
      .addCase(getInvoices.pending, (state) => {
        state.loading = true;
      })
      .addCase(getInvoices.fulfilled, (state, action) => {
        state.loading = false;
        state.invoices = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(getInvoices.rejected, (state) => {
        state.loading = false;
      })
      // make payment
      .addCase(makePayment.pending, (state) => {
        state.loading = true;
      })
      .addCase(makePayment.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(makePayment.rejected, (state) => {
        state.loading = false;
      })
      // get payments
      .addCase(getPayments.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPayments.fulfilled, (state, action) => {
        state.loading = false;
        state.payments = action.payload.data;
        state.meta = action.payload.meta;
      })
      .addCase(getPayments.rejected, (state) => {
        state.loading = false;
      })
      // get account details
      .addCase(getAccountDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAccountDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.accountDetails = action.payload.data;
      })
      .addCase(getAccountDetails.rejected, (state) => {
        state.loading = false;
      })
  },
});

export default billingSlice.reducer;
